import {isAfter, isValid, parseISO, startOfDay} from 'date-fns';
import {calculateAdjustedDeadline} from './adjustedDeadline';

export const PRODUCTION_TRAVELER_STATUSES = [
  'Final Review',
  'To Shop',
  'In Production',
];

function parseComparisonDate(date?: string | Date): Date | null {
  if (!date) {
    return null;
  }

  const parsedDate = date instanceof Date ? date : parseISO(date);
  return isValid(parsedDate) ? startOfDay(parsedDate) : null;
}

export function isProductionTravelerOverdue(
  readyToShipDeadline?: string | null,
  comparisonDate?: string | Date
): boolean {
  const adjustedDeadline = calculateAdjustedDeadline(readyToShipDeadline);
  const parsedComparisonDate = parseComparisonDate(comparisonDate);

  return adjustedDeadline !== null
    && parsedComparisonDate !== null
    && isAfter(parsedComparisonDate, startOfDay(adjustedDeadline));
}
